import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom-black.png'


const _withScopeId = n => (_pushScopeId("data-v-2a5580e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "participation-history" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "page-desc" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = {
  id: "participation-history-filter-status",
  class: "btn btn-secondary d-flex align-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_7 = { class: "filter-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_0
}, null, -1))
const _hoisted_9 = {
  class: "dropdown-menu",
  "aria-labelledby": "participation-history-filter-status"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "dropdown-item" }
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = {
  id: "participation-history-filter-order-by",
  class: "btn btn-secondary d-flex align-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_14 = { class: "filter-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow",
  src: _imports_0
}, null, -1))
const _hoisted_16 = {
  class: "dropdown-menu",
  "aria-labelledby": "participation-history-filter-order-by"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = { class: "list" }
const _hoisted_20 = {
  key: 0,
  class: "pagination-box"
}

import { computed, reactive, ref } from 'vue';
import { USER_REQUEST_STATE_MAP, USER_REQUEST_ORDER_BY_MAP } from '@/constants';
import ParticipationHistoryItem from './components/participation-history-item.vue';
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import { userParticipationRecordStore } from '@/stores';
import { useRoute, useRouter } from 'vue-router';
import { useMobileScrollMore } from '@/hooks/use-mobile-scroll-more';
import qs from 'qs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const store = reactive(userParticipationRecordStore);
const keyword = ref<string>(route.query.keyword as string || '');
const statusValue = ref<string | undefined>('');
const statusList = computed(() => {
  const list = _.map(USER_REQUEST_STATE_MAP, (label, value) => ({ label, value }));
  const jaList = ['approved', 'pending', 'closed'].map(item => ({
    label: USER_REQUEST_STATE_MAP[item as keyof typeof USER_REQUEST_STATE_MAP],
    value: item
  }));
  return [{ label: t('All status'), value: undefined as undefined | string }].concat(locale.value === 'ja' ? jaList : list as Array<{ label: string; value: string | undefined }>);
});
const statusText = computed(() => {
  const item = statusList.value.find(item => item.value === statusValue.value);
  if (!item) {
    return t('All status');
  }
  return item.label;
});
function handleTriggerStatus(value: string | undefined) {
  statusValue.value = value;
  router.push({ query: { ...route.query, state_eq: value, page: 1 } });
}

const orderBy = ref('');
const orderByList = _.map(USER_REQUEST_ORDER_BY_MAP, (label, value) => ({ label, value }));
const orderByText = computed(() => {
  const item = orderByList.find(item => item.value === orderBy.value);
  if (!item) {
    return t('user_request.order_by.title');
  }
  return item.label;
});
function handleChangeOrderBy(value: string) {
  orderBy.value = value;
  router.push({ query: { ...route.query, order_by: value } });
}

function fetchData() {
  if (route.query.state_eq) {
    statusValue.value = route.query.state_eq as string;
  }
  if (route.query.order_by) {
    orderBy.value = route.query.order_by as string;
  }
  const newQuery = _.pick(route.query, ['page', 'keyword', 'state_eq', 'order_by']) as { page?: string; keyword?: string; state_eq?: string; order_by?: string; };
  store.updateQuery({
    page: newQuery.page ? Number(newQuery.page) : 1,
    keyword: newQuery.keyword,
    state_eq: newQuery.state_eq,
    order_by: newQuery.order_by,
  });
  store.fetchData();
}
fetchData();

function handlePageChange(page: number) {
  router.push({ query: { ...route.query, page: page } });
}
function handleSearch() {
  router.push({ query: { ...route.query, keyword: keyword.value, page: 1 } });
}
function handleUpdate() {
  store.fetchData();
}

useMobileScrollMore(async () => {
  await store.fetchMoreData();
  const newQuery = {
    ...route.query,
    page: store.meta.page,
  };
  history.replaceState(null, '', `${window.location.pathname}?${qs.stringify(newQuery)}`);
});

return (_ctx: any,_cache: any) => {
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppPagination = _resolveComponent("AppPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('Participation history')), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('page desc')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_AppSearch, {
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        modelModifiers: { trim: true },
        placeholder: _unref(t)('Searh campaign participation record'),
        onSearch: handleSearch,
        onClear: handleSearch
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(statusText)), 1),
          _hoisted_8
        ]),
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusList), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (handleTriggerStatus(item.value))
            }, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(item.label), 1)
            ], 8, _hoisted_10))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(orderByText)), 1),
          _hoisted_15
        ]),
        _createElementVNode("ul", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderByList), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (handleChangeOrderBy(item.value))
            }, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(item.label), 1)
            ], 8, _hoisted_17))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
        return (_openBlock(), _createBlock(ParticipationHistoryItem, {
          key: index,
          modelValue: _unref(store).data[index],
          "onUpdate:modelValue": ($event: any) => ((_unref(store).data[index]) = $event),
          onUpdate: handleUpdate
        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
      }), 128)),
      (_unref(store).isEmpty)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, {
            key: 0,
            text: _unref(t)('No collection history record')
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).meta.total)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_AppPagination, {
            total: _unref(store).meta.total,
            "per-page": _unref(store).meta.per_page,
            page: _unref(store).meta.page,
            onChange: handlePageChange
          }, null, 8, ["total", "per-page", "page"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})